import {useCallback} from "react";
import {Table} from "@tanstack/react-table";

export function useColumnDnD<TData>(table: Table<TData>) {
    const visibleColumns = table.getVisibleLeafColumns().map((c) => c.id);
    const stateColumnOrder = table.getState().columnOrder;
    const columnOrder = stateColumnOrder.length ? stateColumnOrder : visibleColumns;

    const moveColumn = useCallback(
        (fromRenderIndex: number, toRenderIndex: number) => {
            const visibleColumns = table.getVisibleLeafColumns().map(c => c.id);
            const stateColumnOrder = table.getState().columnOrder;
            const currentOrder = stateColumnOrder.length ? stateColumnOrder : visibleColumns;

            const fromColumnId = visibleColumns[fromRenderIndex];
            const toColumnId = visibleColumns[toRenderIndex];

            const fromIndex = currentOrder.indexOf(fromColumnId);
            const toIndex = currentOrder.indexOf(toColumnId);

            if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

            const newOrder = [...currentOrder];
            const [moved] = newOrder.splice(fromIndex, 1);
            newOrder.splice(toIndex, 0, moved);

            table.setColumnOrder(newOrder);
        },
        [table]
    );


    return {moveColumn, columnOrder};
}
